import React, {useState, useRef, useEffect, useCallback} from 'react'
import React, {useState, useRef, useEffect, useCallback} from 'react'
import fuzzySearch from '../common/fuzzySearch'
import SelectSearch from "react-select-search";
import axios from "axios";
import ReactPaginate from 'react-paginate';

const ActiveAddresses = props =>{
	const {baseUrl,publicUrl, accountLevel,allActiveAddressModalClose,locality,frequencyAmount,selectedFrequencyName,selectedFrequency,saveTestData} = props
	const [addressResponse, setAddressResponse] = useState([])
	const [postsPerPage, setPostsPerPage] = useState(8); 
    const [offset, setOffset] = useState(1);
    const [posts, setAllPosts] = useState([]);
    const [pageCount, setPageCount] = useState(0)
    const [firstLoad, setFirstLoad] = useState(true)
    // for checkbox
    const [selectCheckboxRowIds,setSelectCheckboxRowIds] = useState([])
    const [checkboxIsSelected, setCheckboxIsSelected] = useState(false)
    const [allChecked, setAllChecked] = useState(false)
    const [allRecordIds, setAllRecordIds] = useState([])
    const [allCheckedIds, setAllCheckedIds] = useState([])
    const [selectedCheckbox, setSelectedCheckbox] = useState([])

	useEffect(() => {
		axios.get(baseUrl + 'get-new-all-active-address')
			.then(r => {
				console.log(r.data);
				setAddressResponse(r.data.objAllAddresses)
				handlePagination(r.data.objAllAddresses)
				setAllRecordIds(r.data.addressesIds)
				setTimeout(
					()=>setAllChecked(true),
						setAllRecordIds(r.data.addressesIds),
						setSelectedCheckbox(r.data.addressesIds),
						setSelectCheckboxRowIds(r.data.addressesIds),
						setCheckboxIsSelected(true)
					,4000)
			})
			.catch(e => {
				console.log(e)
			})
	}, [offset])
 const handlePagination = (items) => {
        console.log('in handlePagination')
        console.log('offset ' + offset)

        const data = items;

        if( firstLoad )
        {
            console.log('firstLoad')
            setFirstLoad(false)
            const slice = data.slice(offset - 1 , offset - 1 + postsPerPage)
        }
        else
        {
            console.log('load many time')
            let startIndex = (offset - 1) * postsPerPage; 
            let endIndex = Math.min(startIndex + postsPerPage , data.length); 
            
            console.log('startIndex : ' + startIndex)
            console.log('endIndex : ' + endIndex)
            const slice = data.slice(startIndex , endIndex)
        }

        setAddressResponse(slice)
        setPageCount(Math.ceil(data.length / postsPerPage))
    };
     const handlePageClick = (event) => {
       const selectedPage = event.selected;
       setOffset(selectedPage + 1)

    };

    const AddressSelectedRowClick = (e, addressId) => {
        console.log('in AddressSelectedRowClick')
        console.log('addressId : ' + addressId)

         let selectedCheckboxArray;
         if( selectedCheckbox.indexOf(addressId) > -1 )
         {
             selectedCheckboxArray = selectedCheckbox.filter(item => item !== addressId);
             setSelectedCheckbox(selectedCheckboxArray);
             setSelectCheckboxRowIds(selectedCheckboxArray)
         }
         else
         {
             selectedCheckboxArray = [...selectedCheckbox, addressId];
             setSelectedCheckbox(selectedCheckboxArray);
             setSelectCheckboxRowIds(selectedCheckboxArray)
         }

         console.log(selectedCheckboxArray)
         setSelectedCheckbox(selectedCheckboxArray)

         if( selectedCheckboxArray.length > 0 )
         {
             setCheckboxIsSelected(true)
         }
         else
         {
             setCheckboxIsSelected(false)
         }
    }
    const submitSelectedData =(e)=>{
    	var data = {
    		'type':'search_simulator',
    		'country':saveTestData.country,
    		'state':saveTestData.state,
    		'city':saveTestData.city,
    		'suburb':'',
    		'suburb_type':'',
    		'address':saveTestData.address,
    		'zipcode':saveTestData.postcode,
    		'search_term':saveTestData.keyword,
    		'engine':'google',
    		'language':saveTestData.lang,
    		'freqency':selectedFrequencyName,
    		'frequencyAmount':frequencyAmount,
    		'addresses':selectedCheckbox,
    		'isLocal':locality
    	}
    	console.log('data from submit : ')
    	console.log(data);
    }

function handleSelectAll() {
        console.log('in handleSelectAll');

        allChecked ? setAllChecked(false) : setAllChecked(true);
        allChecked ? setSelectCheckboxRowIds([]) : setSelectCheckboxRowIds(allRecordIds)
        allChecked ? setSelectedCheckbox([]) : setSelectedCheckbox(allRecordIds)
        allChecked ? setCheckboxIsSelected(false) : setCheckboxIsSelected(true)
    }

	return(
		<div className="modal-new-style tools-page" id="saveReport">
            <div className="modal-dialog" style={{width: 1000}}>
		        <div className="modal-content">
		            <div className="modal-header">
		            	<img src={publicUrl + 'img/mobile-moxie.png'} alt="" height="50"/>
                            <h3 className="modal-title" id="addCountrieslabel">
                                Which Addresses would you like to run this keyword for?
                            </h3>
                        <button type="button" className="close" onClick={allActiveAddressModalClose}>
                            <i className="material-icons">clear</i>
                        </button>
		            </div>
		            <div className="modal-body device-selectall-otable">
				    	<div className="container-fluid" style={{height: addressResponse.length > 7 ? 400: 'auto', overflow: 'auto', padding: 0, margin: 0}}>
                         	<table className="table table-striped table-bordered dataTable data-table-country" id="data_table_country">
				        		<thead className="hidden-xs">
				          			<tr>
				            			<th className="no-sort select-all">
				              				<div className="form-group has-feedback text-center">
				                				<button className="btn btn-primary" 
				                				id="selectAllCountry" 
				                				onClick={()=>handleSelectAll()}>Select All</button>
				              				</div>
				            			</th>
				            			<th className="text-center">Address Nickname</th>
                            			<th className="text-center">Address</th>
				            			<th className="text-center">Country</th>
				          				<th className="text-center">State</th>
				            			<th className="text-center">City</th>
				          			</tr>
				        		</thead>
				        		<tbody>
				        			{addressResponse.map((item,i)=>(
				        				<tr
                                    		id={item.id}
                                    		className={'device_' + item.id + (item.isActive ? ' activated' : ' paused')}
                                		>
                                		<td>
							            	<div className="form-group has-feedback text-center">
							                	<div className="checkbox mt-0 mb-0">
							                		<input style={{webkitAppearance:'checkbox',position:'relative',left:17, bottom:5}} type="checkbox"
                                                       className={'styled-checkbox-new exportToGoogleSheetsItem oTable_checkbox country_oTable_checkbox' + (item.isActive ? 'country_oTable_Scheduled' : 'country_oTable_Paused')}
                                                       country-data-checkbox-id={item.id} 
                                                       value={item.id}
                                                       name="exportToGoogleSheets[]"
                                                       onClick={(e) => AddressSelectedRowClick(e, item.id)}
                                                   	   checked={selectCheckboxRowIds.indexOf(item.id) > -1 ? true : false}
                                                	/>
                                                	<label htmlFor="exportToGoogleSheets"></label>
							                	</div>
							            	</div>
							        	</td>
							        	<td className="text-center">
							        		<span>{item.addressNick}</span>
							        	</td>
							        	<td className="text-center">
							        		<span>{item.streetName}</span>
							        	</td>
							        	<td className="text-center">
							        		<span>{item.countryName}</span>
							        	</td>
							        	<td className="text-center">
							        		<span>{item.state}</span>
							        	</td>
							        	<td className="text-center">
							        		<span>{item.city}</span>
							        	</td>
							        </tr>
				        			))}
				        		</tbody>
				       	 	</table>
                        </div>
                        <div className="row">
                        	<div className="col-md-12 col-xs-12">
                            	<ReactPaginate
                               		previousLabel={"previous"}
                               		nextLabel={"next"}
                               		breakLabel={"..."}
                               		breakClassName={"break-me"}
                               		pageCount={pageCount}
                               		onPageChange={handlePageClick}
                               		containerClassName={"pagination"}
                               		subContainerClassName={"pages pagination"}
                               		activeClassName={"active"} />
                        	</div>
                    	</div>
                    	<div className={"modal-footer mt-4"}>
				                	<button 
			                            className="btn btn-primary addKeywordBtn" 
			                            onClick={allActiveAddressModalClose}>Back
			                        </button>
			                         <button
			                            className="btn btn-primary addKeywordBtn "
			                            onClick={(e)=>submitSelectedData(e)}
			                             >Submit
			                            
			                        </button>
				                </div>
				  	</div>
		        </div>
		    </div>
		</div>

	)
}
export default ActiveAddresses